import CallingProvider from 'calling-internal-common/call-provider/records/CallingProvider';
import { getIsThirdPartyCallingPopoverInUse } from 'calling-internal-common/utils/isThirdPartyCallingPopoverInUse';
import { useMemo } from 'react';
import { isSucceeded } from '../../async-data/operators/statusComparators';
import { getIn } from '../../utils/getIn';
import { ThirdPartyHelpDeskPopover, getSelectedProviderFromApplications } from '../components/ThirdPartyHelpDeskPopover';
import { useCalleeDetails } from './useCalleeDetails';
import { jsx as _jsx } from "react/jsx-runtime";
export const useThirdPartyNumbersPopover = props => {
  const {
    appIdentifier,
    subjectId,
    objectTypeId,
    threadId,
    auth
  } = props;
  const gates = getIn(['gates'], auth);
  const {
    data: calleeOmnibusResult,
    status: calleeOmnibusStatus
  } = useCalleeDetails(Number(subjectId), objectTypeId);
  const selectedCallProviderAppId = useMemo(() => {
    return isSucceeded(calleeOmnibusStatus) ? getIn(['selectedThirdPartyProvider'], calleeOmnibusResult, null) : null;
  }, [calleeOmnibusResult, calleeOmnibusStatus]);
  const isThirdPartyCallingPopoverInUse = useMemo(() => {
    if (!isSucceeded(calleeOmnibusStatus)) {
      return false;
    }
    const callingProviders = getIn(['installedCallingSettings', 'installedCallingApplications'], calleeOmnibusResult, []);
    const selectedCallProvider = getSelectedProviderFromApplications(selectedCallProviderAppId, callingProviders);
    return selectedCallProvider ? getIsThirdPartyCallingPopoverInUse(gates || [], new CallingProvider(selectedCallProvider)) : false;
  }, [calleeOmnibusResult, calleeOmnibusStatus, gates, selectedCallProviderAppId]);
  const renderedThirdPartyNumbersPopover = useMemo(() => {
    const {
      onCallButtonClick,
      inboxId,
      visitorPhoneNumber,
      isKnownVisitor
    } = props;
    return /*#__PURE__*/_jsx(ThirdPartyHelpDeskPopover, {
      appIdentifier: appIdentifier,
      "data-test-id": "third-party-numbers-popover",
      inboxId: inboxId,
      objectTypeId: objectTypeId,
      onCallButtonClick: onCallButtonClick,
      subjectId: subjectId,
      visitorPhoneNumber: visitorPhoneNumber,
      isKnownVisitor: isKnownVisitor,
      calleeOmnibusResult: calleeOmnibusResult,
      calleeOmnibusStatus: calleeOmnibusStatus,
      selectedCallProviderAppId: selectedCallProviderAppId,
      threadId: threadId,
      gates: gates || []
    });
  }, [appIdentifier, calleeOmnibusResult, calleeOmnibusStatus, objectTypeId, props, selectedCallProviderAppId, subjectId, threadId, gates]);
  return {
    renderedThirdPartyNumbersPopover,
    isThirdPartyCallingPopoverInUse
  };
};